import template from './tag-form.html';
import controller from './tag-form.controller';
import './tag-form.scss';

export default {
  template,
  controller,
  bindings: {
    tags: '<',
    onCreate: '&',
    onDelete: '&',
  },
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/settings/components/tag-form/index.js